import { path } from 'ramda';
import React from 'react';
import { DashedTitle, Icon, Tabs } from '@fasstech/middle-design-system';
import { useProcess } from '@fasstech/oip-starter-utils/app';
import { ContactSummary } from '@@views/souscriptionRecap/client/components/ContactSummary.jsx';

const CompanyContacts = ({
  hasMultipleContacts,
  contactTabs,
  selectedTab,
  setSelectedTab,
  contacts,
  singleContact,
  getMiddleText
}) => {
  const { processHandlers, context } = useProcess();

  const handleEdit = () => {
    processHandlers.onPrev({
      context: {
        projectId: context?.projectId,
        action: 'ON_EDIT_COMPANY_CONTACTS'
      }
    });
  };

  return (
    <div className="w-full">
      <div className="w-full flex justify-center">
        <Icon name="houseRounded" size="56" />
      </div>
      <DashedTitle>Contacts entreprise</DashedTitle>
      <div className="border border-gray-300 rounded-lg p-6 relative mt-4 flex flex-col gap-2">
        {/* Edit Icon */}
        <button
          type="button"
          onClick={handleEdit}
          className=" p-2 hover:bg-gray-100 rounded-full transition-colors self-end"
          aria-label="Edit company contacts"
        >
          <Icon
            name="circlePen"
            size="36"
            strokeClassName="stroke-primary-500"
          ></Icon>
        </button>
        <div className="flex flex-col  gap-4 w-full">
          {hasMultipleContacts ? (
            <>
              <Tabs
                items={contactTabs}
                selected={selectedTab}
                onClick={(index) => setSelectedTab(index)}
                isDisplayed={contacts.length > 0}
              />
              {path([selectedTab, 'content'], contactTabs)}
            </>
          ) : (
            singleContact && (
              <ContactSummary
                contact={singleContact}
                getMiddleText={getMiddleText}
              />
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanyContacts;
